import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import styles from "./mobileNavBar.module.css";
import { HiOutlineMenuAlt3 } from "react-icons/hi";

function MobileNavBar({
    navItems = [],
    navLogo
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = () => {
    setIsOpen(false);
  };

  return (
    <div className={styles.mobileNavWrap}>
      <div className={styles.navbar}>
        <div className={styles.navLogo}>
          {navLogo && <img src={navLogo.image} alt="Logo" className={styles.logoImage} />}
        </div>
        <button
          type="button"
          className={styles.menuButton}
          aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          <HiOutlineMenuAlt3 size={32} color="var(--fg-default)"/>
        </button>
      </div>

      {isOpen && (
        <div className={styles.mobileMenu}>
          {navItems.map((item) => {
            const isSection = item.path.startsWith('#');
            const target = isSection ? `/home${item.path}` : item.path;
            const sharedProps = {
              key: item.name,
              className: styles.menuItem,
              onClick: () => {
                if (item.scrollToTop) {
                  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                }
                handleItemClick();
              },
            };

            if (isSection) {
              return (
                <NavHashLink smooth to={target} {...sharedProps}>
                  {item.name}
                </NavHashLink>
              );
            }

            return (
              <Link to={target} {...sharedProps}>
                {item.name}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  )
}

export default MobileNavBar
